var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Dialog } from '@material-ui/core';
import { Form, Field } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';
import { getTranslation } from '../../../../translation';
import { renderTextField } from '../../../reusable/formElements';
var required = function (value) {
    return value ? undefined : 'Required';
};
var styles = function (theme) { return ({
    content: {
        width: 500,
        // minHeight: 300,
    },
}); };
var formFields = {
    firstName: 'firstName',
    lastName: 'lastName',
    phoneNumber: 'phoneNumber',
    title: 'title',
    description: 'description',
};
// @ts-ignore
var SupportForm = /** @class */ (function (_super) {
    __extends(SupportForm, _super);
    function SupportForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.onClose(values);
                return [2 /*return*/];
            });
        }); };
        _this.handleCancel = function () {
            _this.props.onClose();
        };
        return _this;
    }
    SupportForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, confirmLabel = _a.confirmLabel, descriptionText = _a.descriptionText, title = _a.title, hideTitle = _a.hideTitle, translate = _a.translate, open = _a.open;
        return (React.createElement(Form, { onSubmit: this.onSubmit, destroyOnUnregister: true, initialValues: {
                firstName: localStorage.getItem('firstName') || '',
                lastName: localStorage.getItem('lastName') || '',
                phoneNumber: localStorage.getItem('phoneNumber') || '',
            }, render: function (_a) {
                var handleSubmit = _a.handleSubmit, form = _a.form, submitting = _a.submitting, pristine = _a.pristine, values = _a.values;
                return (React.createElement(Dialog, { disableBackdropClick: true, disableEscapeKeyDown: true, open: open, maxWidth: "md", "aria-labelledby": "error-dialog" },
                    React.createElement("form", { onSubmit: handleSubmit },
                        React.createElement(DialogTitle, { id: "zendesk-form-title" }, title),
                        React.createElement(DialogContent, { className: classes.content },
                            React.createElement("div", null,
                                !hideTitle && (React.createElement("div", null,
                                    React.createElement(Field, { validate: required, fullWidth: true, id: "title", className: "mb-16", name: formFields.title, label: translate('issue-title') + "*", component: renderTextField }))),
                                React.createElement(Field, { id: "description", className: "mb-16", multiline: true, fullWidth: true, rows: 1, rowsMax: 5, name: formFields.description, label: translate(descriptionText || 'issue-description'), component: renderTextField }),
                                React.createElement("span", { style: { marginRight: 9 } },
                                    React.createElement(Field, { validate: required, id: "firstName", className: "mb-16 ", name: formFields.firstName, label: translate('firstName') + "*", component: renderTextField })),
                                React.createElement(Field, { validate: required, id: "lastName", className: "mb-16", name: formFields.lastName, label: translate('lastName') + "*", component: renderTextField })),
                            React.createElement("div", null,
                                React.createElement(Field, { id: "phoneNumber", fullWidth: true, className: "mb-16", name: formFields.phoneNumber, label: translate('phoneNumber'), component: renderTextField }))),
                        React.createElement(DialogActions, null,
                            React.createElement(Button, { name: "Cancel", id: "cancel-btn", onClick: _this.handleCancel, color: "primary" }, translate('cancel')),
                            React.createElement(Button, { name: "Submit", id: "submit-form0btn", type: "submit", color: "primary" }, confirmLabel)))));
            } }));
    };
    SupportForm = __decorate([
        withStyles(styles),
        connect(function (state, ownProps) {
            return __assign(__assign({}, ownProps), { translate: getTranslation(state.translation.lang) });
        }, null)
    ], SupportForm);
    return SupportForm;
}(React.Component));
export { SupportForm };



//////////////////
// WEBPACK FOOTER
// ./src/components/routes/channel/users/SupportForm.tsx
// module id = 466
// module chunks = 81